export const CURENCIES = "CURENCIES";
export const LOADER = "LOADER";
export const BASEAMOUNT = "BASEAMOUNT";

export function pushLoader(values) {
  // console.log(values)
  return {
    type: LOADER,
    payload: values
  };
}
